<template>
    <div class="sub-header">
        <nav class="navbar navbar-expand">
            <div class="collapse navbar-collapse d-flex w-100 pb-4 justify-content-between">

                <form v-if="searchShow" @submit.prevent="handleSearch" class="form-inline d-flex pr-0 w-100" method="get">
                    <v-row>
                        <v-col cols="12" lg="12" class="menu-responsive">
                            <ul class="navbar-nav d-flex jusitify-content-center">
                                <v-spacer class="spacer-menu"></v-spacer>
                                <li class="px-0 nav-item d-flex align-items-center">
                                    <Link :class="{'select-highlight': '' === currentSlug}" style="font-size: 20px;"  class="nav-link font-size-responsive" :href="route('home.index')">
                                        {{ $t('submenu.home') }}
                                    </Link>
                                </li>
                                <li class="px-0 nav-item d-flex align-items-center" v-for="(menu, index) in menuCategories"
                                    :key="index">
                                    <Link :class="{'select-highlight': route('search',menu.slug)+'?search='+search === currentSlug}" style="font-size: 20px;"  class="nav-link font-size-responsive" :href="route('search',menu.slug)+'?search='+search">
                                        {{ $t('submenu.'+menu.slug) }}
                                    </Link>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                </form>

            </div>
        </nav>
    </div>
</template>

<script setup>

import {computed, ref} from "vue";
const menuCategories = computed(() => usePage().props.menu_categories);
const emit = defineEmits(['onSearch']);
const searchTerm = ref('');

const props = defineProps({
    searchShow: Boolean,
    search: String,
});


function handleSearch() {
    emit('onSearch', searchTerm.value);
}

const currentSlug = computed(() => {
    const url = window.location.href;
    return decodeURIComponent(url);
});

import {Link, usePage} from "@inertiajs/vue3";

</script>

<style scoped>
@media (max-width: 768px) {
    .font-size-responsive {
        font-size: 18px !important;
    }
    .menu-responsive {
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .spacer-menu {
        display: none;
    }
    .navbar-nav {
        overflow-x: auto;
    }
}
.navbar-nav {
    overflow-x: scroll;
    scrollbar-width: none; /* Firefox */
}
.navbar-nav::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
}
.navbar-nav {
    scroll-behavior: smooth;
}
.custom-search {
    border-radius: 50px;
    background-color: #F0F0F080;
    border: none;
    padding-left: 20px;
    padding-right: 20px;
    height: 45px;
}
.fa-search:before {
    margin-right: 10px;
}
.custom-search:focus {
    box-shadow: none;
    outline: none;
}

.search-wrapper {
    position: relative;
    max-width: 100%;
    flex: 1;
}

.search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
}




</style>
